/* Tidy Towel (Oct 2026, preview): sets-of-3 maths shared by the deal page, the product sticky bar and /cart, plus a guard
   for the old line-order bug.
   window.ttSets(prices[]) -> { n, list, total, save, sets, k, nextSave, inset[] } for "Any 3 for $39 in sets of 3":
   units sorted most expensive first (ties: earlier = older first, so the newest equal-priced towel is the leftover); the first 3 x floor(n/3) form complete sets, the rest (the
   cheapest) pay list price. In-set price: rule "native" = list - $3.99 (single $13, double-sided $15, what ONE repeating
   native Buy X Get Y gives), rule "exact" = $13 (needs a Discount Function). Same rule as snippets/tt-deal-calc.liquid.
   window.ttCartSets(cart) applies it to the eligible lines of a /cart.js response (adds real = their final total).
   ttDealFix: Shopify's OLD 4 automatic discounts were line-order dependent (double-sided added first priced some mixes $2
   high). Re-adding the double-sided lines fixed that. It now only runs when the real price of the deal towels is ABOVE the
   sets-of-3 total, which the old discounts never are (they give $13 each at 3+) and the new single discount can't be
   (order-independent), so after the discount switch it is a dormant safety net and can be deleted. */
(function () {
  if (window.ttDealFix) return;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cfg = window.ttDealCfg || {}, TYPE = cfg.type || 'Kitchen Towel', UNIT = cfg.unit || 1300, MIN = cfg.min || 3;
  var SINGLE = cfg.single || 1699, RULE = cfg.rule || 'native', OFF = SINGLE - UNIT;
  function setPrice(p) { return RULE === 'exact' ? UNIT : p - OFF; }
  function sets(prices) {
    var u = prices.map(function (p, i) { return { p: p, i: i }; }).sort(function (a, b) { return b.p - a.p || a.i - b.i; });
    var n = u.length, ns = Math.floor(n / MIN), cut = ns * MIN, list = 0, total = 0, lo = 0, inset = [];
    u.forEach(function (x, j) { list += x.p; if (j < cut) { total += setPrice(x.p); inset[x.i] = true; } else { total += x.p; lo += x.p; inset[x.i] = false; } });
    var k = MIN - (n % MIN);
    var nextSave = RULE === 'exact' ? lo + k * SINGLE - MIN * UNIT : MIN * OFF;
    /* lo / loN: leftover towels' list total and count. loSingle = every leftover is a $16.99 single, so "next set is $13 each" is true */
    return { n: n, list: list, total: total, save: list - total, sets: ns, k: k, nextSave: nextSave, inset: inset, lo: lo, loN: n - cut, loSingle: lo === (n - cut) * SINGLE };
  }
  function elig(i) { return i.product_type === TYPE && !i.selling_plan_allocation; }
  function cartSets(c) {
    var pr = [], real = 0;
    (c && c.items || []).filter(elig).reverse().forEach(function (i) { /* oldest line first, like the picks */ real += i.final_line_price; for (var q = 0; q < i.quantity; q++) pr.push(i.original_price); });
    var r = sets(pr); r.real = real; return r;
  }
  window.ttSets = sets; window.ttCartSets = cartSets;
  window.ttDealRule = { unit: UNIT, min: MIN, single: SINGLE, rule: RULE, off: OFF, setPrice: setPrice };
  var H = { 'Content-Type': 'application/json', Accept: 'application/json' };
  function post(p, b) {
    return fetch(ROOT + p, { method: 'POST', headers: H, credentials: 'same-origin', body: JSON.stringify(b) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function getCart() { return fetch(ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function isDS(i) { return /double[- ]sided/i.test((i.handle || '') + ' ' + (i.product_title || '')); }
  function needFix(c) {
    var el = (c.items || []).filter(elig), r = cartSets(c);
    if (r.n < MIN || r.real <= r.total + 1) return null;
    var ds = el.filter(isDS);
    if (!ds.length || c.items.slice(0, ds.length).every(isDS)) return null; /* nothing to re-order */
    return ds;
  }
  var tried = {}, inflight = null;
  window.ttDealFix = function (cart) {
    if (inflight) return inflight; /* one fix at a time: callers share the running one */
    inflight = runFix(cart);
    inflight.then(function () { inflight = null; }, function () { inflight = null; });
    return inflight;
  };
  function runFix(cart) {
    return (cart && cart.items ? Promise.resolve(cart) : getCart()).then(function (c) {
      var ds = needFix(c); if (!ds) return null;
      var sig = c.token + '|' + c.item_count + '|' + c.total_price; if (tried[sig]) return null; tried[sig] = 1;
      var up = {}, add = [];
      ds.forEach(function (i) {
        up[i.key] = 0;
        var o = { id: i.variant_id, quantity: i.quantity };
        if (i.properties && Object.keys(i.properties).length) o.properties = i.properties;
        add.push(o);
      });
      return post('cart/update.js', { updates: up }).then(function () {
        return post('cart/add.js', { items: add }).catch(function () { return post('cart/add.js', { items: add }); });
      }).then(getCart);
    }).catch(function () { return null; });
  }
  /* one-tap checkout used by the deal tray and the product-page sticky bar: guard first (no-op unless overpriced), then /checkout */
  window.ttGoCheckout = function () {
    return window.ttDealFix().then(function () { window.location.href = ROOT + 'checkout'; });
  };
  /* Fixed bottom bars (deal tray, sticky product bar) read --tt-pbar so they sit ABOVE Shopify's theme-preview bar
     (68px, fixed to the bottom; only shown in preview, shoppers never see it) and --tt-hdr (sticky header height). */
  var de = document.documentElement;
  function measure() {
    var el = document.getElementById('PBarNextFrameWrapper') || document.getElementById('preview-bar-iframe'), h = 0;
    if (el) {
      var r = el.getBoundingClientRect(), cs = getComputedStyle(el);
      if (cs.position === 'fixed' && cs.display !== 'none' && cs.visibility !== 'hidden' && r.height > 0 && r.height < 200 && r.bottom >= window.innerHeight - 2) h = Math.max(0, Math.round(window.innerHeight - r.top));
    }
    de.style.setProperty('--tt-pbar', h + 'px');
    var hd = document.querySelector('.section-header.shopify-section-header-sticky, .section-header');
    var stuck = hd && getComputedStyle(hd).position === 'sticky' && !hd.classList.contains('shopify-section-header-hidden');
    de.style.setProperty('--tt-hdr', (stuck ? Math.round(hd.getBoundingClientRect().height) : 0) + 'px');
    try { document.dispatchEvent(new CustomEvent('tt:measure')); } catch (e) {}
  }
  window.ttMeasure = measure;
  var mt; function soon() { clearTimeout(mt); mt = setTimeout(measure, 120); }
  document.addEventListener('DOMContentLoaded', function () {
    measure(); [800, 2000, 4500, 9000].forEach(function (d) { setTimeout(measure, d); });
    window.addEventListener('resize', soon);
    try { new MutationObserver(soon).observe(document.body, { childList: true }); } catch (e) {}
  });
  /* /cart page: check on load and after every quantity change there; reload once if the cart was re-ordered */
  function onCartPage() { return !!document.querySelector('cart-items') && /\/cart\/?$/.test(location.pathname); }
  function cartPageFix() { window.ttDealFix().then(function (c) { if (c) location.reload(); }); }
  document.addEventListener('DOMContentLoaded', function () {
    if (!onCartPage()) return;
    cartPageFix();
    try { subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) { if (e && e.source === 'cart-items') cartPageFix(); }); } catch (e) {}
  });
})();
